import { InGuardGenerate } from "@/shared/guards";
import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import TalentStore from "../store";
import TalentRouterApp from "../views/Router.App.vue";
/**
 * Pages
 */
import MatchedOpportunitiesPage from "../views/opportunities-page/matched-opportunities.page.vue";
import ActiveOpportunitiesPage from "../views/opportunities-page/active-opportunities.page.vue";
/**
 *
 */
import AccountAccountPage from "@/shared/views/account-pages/account-page/account-page.vue";
import AccountProfilePage from "@/shared/views/account-pages/account-profile-page/account-profile-page.vue";
import AccountSettingsPage from "@/shared/views/account-pages/account-settings-page/account-settings-page.vue";
import OpportunityPage from "@/@business/views/opportunity-page/opportunity-page.vue";

/**
 *
 */
import BiddingsPage from "../views/biddings-page/biddings-page.vue";
/**
 *
 */
const TalentRoutes: Array<RouteRecordRaw> = [
  {
    path: "",
    beforeEnter: InGuardGenerate(TalentStore),
    component: TalentRouterApp,
    children: [
      {
        path: "",
        redirect: "/opportunities/active",
      },
      {
        path: "opportunities/active",
        component: ActiveOpportunitiesPage,
      },
      {
        path: "opportunities/matched",
        component: MatchedOpportunitiesPage,
      },
      {
        path: "opportunities/:id",
        component: OpportunityPage,
      },
      {
        path: "biddings",
        component: BiddingsPage,
      },
      /**
       * Account Related Routes
       *
       * 1. Account : email, names, joinedAt, then type, Security: password, sessions e.t.c
       * 2. profile: Profile Page
       * 3. Settings: Bidding, currency, e.t.c
       * 4. startups: if founder
       */
      {
        path: "account",
        redirect: "/account/account",
      },
      {
        path: "account/account",
        component: AccountAccountPage,
      },
      {
        path: "account/settings",
        redirect: 'account/account'
        // component: AccountSettingsPage,
      },
      {
        path: "account/profile",
        component: AccountProfilePage,
      },
      {
        path: "account/:pathMatch(.*)*",
        redirect: "/account/account",
      },
    ],
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/opportunities/active",
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: TalentRoutes,
});

export default router;
